export const zhTW = {
  // 充值相關
  deposit: {
    title: '充值',
    chain: '鏈',
    asset: '資產',
    amount: '數量',
    available: '可用',
    equity: '總資產',
    confirmDeposit: '充值確認',
    switchNetwork: '切換網絡',
    max: '最大',
    arrivalTime: '到帳時間',
    minDeposit: '最小儲值金額',
    minDepositParsed: '最少充值 {{amount}} {{token}}',
    maxDeposit: '最大儲值金額',
    depositTipFor25w:
      '單筆充值金額上限為 200,000。若充值金額大於 200,000，請使用 Ethereum 鏈充值。',
    depositAllTip:
      '僅支援發送 {{coin}} ({{v}}) 資產到此位址。\n 充值金額大於 200,000 時，到账時間可能會有延遲，請耐心等待。',
    enableSystemProWithToken: '在{{network}}上啓用{{token}}',
    enableTokenDesc: '您首次在{{network}}上存款時必須啓用{{token}}。',
    enableWithToken: '啓用 {{token}}',
    arrivaltimeTooltip1:
      '資金約在 {{v}} 分鐘內（達到 {{v1}} 個區塊確認後）到賬。',
    arrivaltimeTooltip2:
      '預計時間是根據歷史資料計算所得，僅供參考。網路壅塞可能會導致實際到帳時間變長。',
    arrivalEstimated: '≈ {{v}}分鐘',
    availableDesc:
      '您可以充值的最大金額。當可用餘額為0或負數時，無法進行充值。',
    noPrivateKeyWalletWarning:
      '請勿使用無私鑰錢包進行充值，無私鑰錢包充值會導致資金損失且無法追回。',
    layerZeroDepositTip:
      '系統會根據充值資金的實際情況，通過 LayerZero 完成您的充值。',
    layerZeroDepositTipExceedPool:
      '由於充值資金大於資金池，將透過 LayerZero 完成您的充值。',
    layerZeroDepositTipGte200k:
      '由於充值資金大於等於 200,000 USDT，將透過 LayerZero 完成您的充值。',
    layerZeroDepositButton: '使用LayerZero充值',
  },
  withdraw: {
    noticeDesc:
      '普通提現是一個兩步過程。此步驟將發起您的提現請求，並將在 Layer2 進行處理。一旦資金準備就緒（可能需要最多 4 小時），您將收到一條將資金提現到錢包的通知。受鏈同步等情況影響下，時長可能需要長達 48 小時。您需要自行承擔交易 gas 費用。',
    crossChainTips:
      '跨鏈提幣需在 L2（通過零知識證明）進行驗證。提幣過程最多約需2小時。相關鏈的資產池中需有充足的資金來處理跨鏈提幣，其間還將產生礦工費。 edgeX 將收取一定的手續費作爲礦工費。',
    commonWithdraw: '提現說明',
    withdraw: '提現',
    speed: '速度',
    confirmWithdraw: '提現確認',
    speedNote: '處理時間：',
    speedNoteSpeed1: '用時約8分鐘',
    speedNoteSpeed2: '用時約 2-4 小時',
    speedNoteSpeed3: '用時約4小時',
    receiverAddress: '接收地址',
    fee: '手續費',
    feeRate: '費率',
    withdrawlAmount: '提現金額',
    amountToReceive: '到账金額',
    invalidReceiverAddress: '接收地址不能為空',
    availableDesc:
      '您可以提現的最大金額。當可用餘額為0或負數時，無法進行提現。',
    feeCalculationTip:
      '提現手續費按照提現金額乘以費率計算，最低為 1 USDT/USDC。費率會根據鏈上實際情況進行調整。',
    crossChainPoolBalance: '跨鏈資金池餘額',
    poolBalance: '資金池餘額',
    poolBalanceInsufficientTip:
      '提現金額大於資金池餘額，無法進行提現。請選擇資金池餘額充足的選項。',
  },
  account: {
    title: '帳戶',
    perpetual: '合約帳戶',
    spot: '現貨帳戶',
  },
}

export default zhTW
